
const CODE_SEND_TIME_KEY = "pabbit_code_send_times";
const CODE_SEND_INTERVAL = 60; 

interface CodeSendTimes {
  [phone: string]: number;
}


const getCodeSendTimes = (): CodeSendTimes => {
  try {
    const data = window.localStorage.getItem(CODE_SEND_TIME_KEY);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error("Failed to parse code send times:", error);
    return {};
  }
};


const saveCodeSendTimes = (times: CodeSendTimes): void => {
  try {
    window.localStorage.setItem(CODE_SEND_TIME_KEY, JSON.stringify(times));
  } catch (error) {
    console.error("Failed to save code send times:", error);
  }
};


export const recordCodeSendTime = (phone: string): void => {
  const times = getCodeSendTimes();
  times[phone] = Date.now();
  saveCodeSendTimes(times);
};


export const getCodeSendTime = (phone: string): number => {
  const times = getCodeSendTimes();
  return times[phone] || 0;
};


export const canSendCode = (phone: string): { canSend: boolean; remainingSeconds: number } => {
  const lastSendTime = getCodeSendTime(phone);
  
  if (!lastSendTime) {
    return { canSend: true, remainingSeconds: 0 };
  }
  
  const now = Date.now();
  const elapsedSeconds = Math.floor((now - lastSendTime) / 1000);
  const remainingSeconds = Math.max(0, CODE_SEND_INTERVAL - elapsedSeconds);
  
  return {
    canSend: remainingSeconds === 0,
    remainingSeconds,
  };
};


export const clearCodeSendTime = (phone: string): void => {
  const times = getCodeSendTimes();
  delete times[phone];
  saveCodeSendTimes(times);
};


export const clearAllCodeSendTimes = (): void => {
  window.localStorage.removeItem(CODE_SEND_TIME_KEY);
};

